import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Translate } from "@phosphor-icons/react";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";

// Superadmin switch: show Malayalam translation buttons in the customer app chat.
export default function CustomerTranslationToggle() {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/chat/assist/customer-translation").then(r => setS(r.data)).catch(() => setS({ enabled: false })); }, []);
  if (!s) return null;
  const canEdit = user?.role === "superadmin";
  const flip = async () => {
    setBusy(true);
    try {
      const r = await api.put("/chat/assist/customer-translation", { enabled: !s.enabled });
      setS({ ...s, ...r.data }); toast.success(`Customer chat translation ${r.data.enabled ? "turned on" : "turned off"}`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white border border-[#E5E2D9] rounded-xl p-4 flex items-center gap-4" data-testid="cust-translation-card">
      <Translate size={22} className="text-[#B45309] shrink-0" />
      <div className="flex-1">
        <div className="font-semibold text-sm">Malayalam translation in customer chat</div>
        <div className="text-xs text-[#5C5A55]">When on, customers see "Translate to Malayalam" on messages and a മല button in the chat box.
          {!canEdit && " Only a superadmin can change this."}</div>
        {s.updated_by_name && <div className="text-[10px] text-[#8A8780] mt-0.5">Last changed by {s.updated_by_name}</div>}
      </div>
      <button onClick={flip} disabled={!canEdit || busy} role="switch" aria-checked={s.enabled} data-testid="cust-translation-toggle"
        className={`relative w-12 h-7 rounded-full transition-colors disabled:opacity-50 ${s.enabled ? "bg-[#15803D]" : "bg-[#D6D3CB]"}`}>
        <span className={`absolute left-0 top-1 h-5 w-5 rounded-full bg-white shadow transition-transform ${s.enabled ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </div>
  );
}
